export const GET_UPCOMING_BOOKINGS = 'get-upcoming-bookings';
const getUpcomingBookings = ({ page = 1 }) => ({
  type: GET_UPCOMING_BOOKINGS,
  payload: { page },
});
export default getUpcomingBookings;
